import { Component, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LanguageChangeService } from '../../../../shared/services/language-change.service'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() lang: string = '';

  ggLogo = 'https://cdn.ggboost.com/images/gg_logo_white.webp';
  ggLogoFallback = 'https://cdn.ggboost.com/images/gg_logo_white.png';
  methods = 'https://cdn.ggboost.com/images/visa-method.webp';
  year = new Date().getFullYear();

  langUrlPrefix: string = '';

  page = {
    en: {
      footerText: `
        League of Legends, Valorant, Teamfight Tactics and Wild Rift are registered trademarks of Riot Games, Inc.
        Apex Legends is a registered trademark of Electronic Arts, Inc.
        CS2 is a registered trademark of Valve Corporation.
        Marvel Rivals is a registered trademark of Marvel Characters, Inc.
        We are in no way affiliated with, associated with or endorsed by any of those companies.
      `,
      allRightsReserved: "All Rights Reserved"
    },
    fr: {
      footerText: `
        League of Legends, Valorant, Teamfight Tactics et Wild Rift sont des marques déposées de Riot Games, Inc.
        Apex Legends est une marque déposée d’Electronic Arts, Inc.
        CS2 est une marque déposée de Valve Corporation.
        Marvel Rivals est une marque déposée de Marvel Characters, Inc.
        Nous ne sommes en aucun cas affiliés, associés ou approuvés par l’une de ces sociétés.
      `,
      allRightsReserved: "Tous droits réservés"
    },
    de: {
      footerText: `
        League of Legends, Valorant, Teamfight Tactics und Wild Rift sind eingetragene Marken von Riot Games, Inc.
        Apex Legends ist eine eingetragene Marke von Electronic Arts, Inc.
        CS2 ist eine eingetragene Marke der Valve Corporation.
        Marvel Rivals ist eine eingetragene Marke von Marvel Characters, Inc.
        Wir stehen in keinerlei Verbindung mit diesen Unternehmen und werden von ihnen auch nicht unterstützt.
      `,
      allRightsReserved: "Alle Rechte vorbehalten."
    },
    pt: {
      footerText: `
        League of Legends, Valorant, Teamfight Tactics e Wild Rift são marcas registadas da Riot Games, Inc.
        Apex Legends é uma marca registada da Electronic Arts, Inc.
        CS2 é uma marca registada da Valve Corporation.
        Marvel Rivals é uma marca registada da Marvel Characters, Inc.
        Não somos de forma alguma afiliados, associados ou endossados por nenhuma dessas empresas.
      `,
      allRightsReserved: "Todos os direitos reservados"
    },
    es: {
      footerText: `
        League of Legends, Valorant, Teamfight Tactics y Wild Rift son marcas registradas de Riot Games, Inc.
        Apex Legends es una marca registrada de Electronic Arts, Inc.
        CS2 es una marca registrada de Valve Corporation.
        Marvel Rivals es una marca registrada de Marvel Characters, Inc.
        No estamos de ninguna manera afiliados, asociados o respaldados por ninguna de estas compañías.
      `,
      allRightsReserved: "Todos los derechos reservados"
    }
  }

  constructor(
    private languageChangeService: LanguageChangeService,
  ) {
    this.languageChangeService.languageChanges().pipe(takeUntilDestroyed()).subscribe((newLang: string) => {
      this.lang = newLang;

      if (this.lang !== 'en') {
        this.langUrlPrefix = '/' + this.lang;
      } else {
        this.langUrlPrefix = '';
      }
    });
   }
}